export const canAccessDetail = role =>
  role === 'owner' || role === 'administrator';

export default canAccessDetail;
